import { cssVars } from '@/app/styles';
import { Charts } from '@/chart/chart';
import { BarChartOptions } from '@/chart/chart-options';
import { DEFAULT_CHART_BASE_TYPE } from '@/chart/components/all-charts-styles';
import { DisplayMinMaxValuePlugin } from '@/chart/plugins/display-min-max-value-plugin';
import { datasetTypes } from '@/constants';
import {
  ChartDataBuilder,
  constructDatasets,
} from '@/utils/chart-data-builder';
import { numberWithCommas } from '@/utils/string-utils';

class BookedRatioDataBuilder extends ChartDataBuilder {
  constructor(data, barThickness = 10) {
    super(data);
    this.barThickness = barThickness;
    this.dataPoints = data.dataPoints;
    this.data = this.extractBookedRatioData();
  }

  get configurations() {
    return [
      {
        backgroundColor: '#c7d1f3',
        barThickness: this.barThickness,
      },
      {
        backgroundColor: '#37A3BC',
        barThickness: this.barThickness,
      },
      {
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
        barThickness: this.barThickness,
      },
    ];
  }

  extractBookedRatioData() {
    const datasetVacant = [];
    const datasetBook = [];
    const datasetBlock = [];

    this.dataPoints.forEach((dataPoint) => {
      const { vacant, booked, blocked } = dataPoint;
      datasetVacant.push(vacant && vacant.value);
      datasetBook.push(booked && booked.value);
      datasetBlock.push(blocked && blocked.value);
    });

    const datasets = [datasetBlock, datasetBook, datasetVacant];

    return datasets;
  }

  get retrieveDatasets() {
    return constructDatasets(
      this.labels,
      this.data,
      'bar',
      this.configurations
    );
  }
}

class BookedRatioChart extends Charts {
  static pluginParams = {
    pluginTextColor: cssVars.chartColors.STACKED_BOOKED_RATIO,
    pluginFormatter: numberWithCommas,
    pluginAlignment: 'top',
  };

  static tooltipParams = {
    unit: '%',
  };

  static isStackedBar = true;

  static getParams() {
    return {
      pluginParams: this.pluginParams,
      tooltipParams: this.tooltipParams,
      isStackedBar: this.isStackedBar,
    };
  }

  static getOptions(props) {
    return {
      ...this.getParams(),
      ...props,
    };
  }

  constructor(props) {
    super({
      DataBuilder: BookedRatioDataBuilder,
      chartProps: props,
      name: datasetTypes.STACKED_BOOKED_RATIO,
      options: new BarChartOptions(BookedRatioChart.getOptions(props))
        .chartOptions,
      baseType: DEFAULT_CHART_BASE_TYPE,
      plugins: [DisplayMinMaxValuePlugin()],
    });
  }
}

const chart = (props) => new BookedRatioChart(props).chart;

export default chart;
